import { useEffect } from 'react';
import { useImperativeTimeout } from './useImperativeTimeout';

const useDeclarativeTimeout = (callback, delay) => {
  const handle = useImperativeTimeout(callback, delay);
  useEffect(() => {
    if (![null, undefined].includes(delay)) {
      handle.set();
      return handle.clear;
    }
  }, [delay]);
}

export { useDeclarativeTimeout };